"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _editor = _interopRequireDefault(require("@insided/deprecated-preact-components/editor"));

var _EditableInputWithVariable = _interopRequireDefault(require("../../ui-components/EditableInputWithVariable"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _utils = require("../utils");

var CreateEmailForm = function CreateEmailForm(_ref) {
  var subject = _ref.subject,
      onSubjectChanged = _ref.onSubjectChanged,
      subjectError = _ref.subjectError,
      _ref$previewText = _ref.previewText,
      previewText = _ref$previewText === void 0 ? '' : _ref$previewText,
      onPreviewTextChanged = _ref.onPreviewTextChanged,
      content = _ref.content,
      onContentChanged = _ref.onContentChanged,
      onEmailCreateDone = _ref.onEmailCreateDone;
  return (0, _preact.h)("div", {
    className: "create-email-campaign-form"
  }, (0, _preact.h)(_InputGroup.default, {
    title: "Subject",
    customInput: (0, _preact.h)(_EditableInputWithVariable.default, {
      customClass: "qa-create-email-subject",
      value: subject,
      onChange: function onChange(value) {
        return onSubjectChanged(value);
      },
      maxLength: 250,
      error: !!subjectError
    }),
    newStyle: true,
    error: subjectError
  }), (0, _preact.h)(_InputGroup.default, {
    title: "Preview text",
    customInput: (0, _preact.h)(_EditableInputWithVariable.default, {
      customClass: "qa-create-email-preview-text",
      value: previewText,
      onChange: function onChange(value) {
        return onPreviewTextChanged(value);
      },
      maxLength: _utils.PREVIEW_TEXT_LENGTH
    }),
    newStyle: true
  }), (0, _preact.h)(_InputGroup.default, {
    title: "Email design",
    newStyle: true,
    customInput: (0, _preact.h)(_editor.default, {
      profile: "email",
      data: content,
      onChange: function onChange(content) {
        return onContentChanged(content);
      },
      disableFileAttachments: true,
      disableMentions: true,
      isControl: true
    })
  }), (0, _preact.h)(_Button.default, {
    title: "Done",
    variant: "brand",
    size: "medium",
    onClick: onEmailCreateDone,
    className: "qa-create-email-done",
    "data-track-type": "click",
    "data-element-name": "Done button"
  }));
};

var _default = CreateEmailForm;
exports.default = _default;